module.exports = __webpack_public_path__ + "img/Realisme_De_fire_store_Lie.6ca17606.jpg";